module.exports = __webpack_public_path__ + "img/salama.1da71f3b.png";